import Mobileweekdays from './mobileweekdays';
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from "react-i18next";
import translations from "../../Components/Translations/Translations";
import { FiSunrise } from "react-icons/fi";
import { FiSunset } from "react-icons/fi";
import { PiMoon } from "react-icons/pi";
import { SlStar } from "react-icons/sl";
import axios from 'axios';
import Calmoon from "../../img/icons/calmoon.svg";
import { normalDayStyles, getDayStyles } from './mobiledaystyles';
import Festivals from './festivals';
import { FaChevronLeft } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";
import Notes from './notes';
import Weekdays from './weekdays';
import { ekadashiTranslations, purnimaTranslations, amavasyaTranslations } from './translations';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setDate } from '../../store/slice/dateSlice';
import httpService from "../../common/http.service";
import Loading from '../../Components/Loading/Loading';

const Mobilecalendar = () => {
    const [loading, setLoading] = useState(false);
    const [panchangloading, setPanchangLoading] = useState(true);
    const [events, setEvents] = useState([]);
    const [holidays, setHolidays] = useState([]);
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const app_language = "en";
    const data_language = i18n.language;
    const storedLanguage = localStorage.getItem("lang") || "en";
    const selectedTranslation = translations[storedLanguage] || translations.en;
    const date = moment(new Date()).format("DD/MM/YY");
    const curr_date = useSelector((state) => state.date.date);
    // const currentDate = moment();// for Dynamic month
    // const monthStart = currentDate.startOf('month');// for Dynamic month
    const [monthStart, setMonthStart] = useState(moment().date(1)); // for testing purpose any month by number  january from 1
    const [panchangDetails, setpanchangDetails] = useState([]);
    const monthEnd = monthStart.clone().endOf('month');
    const startDate = monthStart.day();
    const adjustedStartDate = (startDate === 0 ? 6 : startDate - 1);
    const monthName = monthStart.format('MMMM');
    const [currentYear, setCurrentYear] = useState(moment().year());
    const today = moment();
    const Todaysdate = today.format('DD MMMM YYYY dddd');

    const isTithiPresent = (todayEvents, tithiName, tithiTranslations) => {
        if (storedLanguage === 'te') {
            if (todayEvents && Array.isArray(todayEvents) && todayEvents.length > 0 &&
                Array.isArray(todayEvents[0].Tithulu)) {
                const tithuluSplit = todayEvents[0].Tithulu[0].split(' ')[0].trim();
                if (tithuluSplit === tithiName) {
                    return true;
                }
                return false;
            }
        }
        else {
            return todayEvents && Array.isArray(todayEvents) && todayEvents.length > 0 &&
                todayEvents[0].Tithi && Array.isArray(todayEvents[0].Tithi) && todayEvents[0].Tithi.length > 0 &&
                tithiTranslations.includes(todayEvents[0].Tithi[0].split(' ')[0]);
        }
    };

    const fetchMonthlyPanchang = async () => {
            setLoading(true);
            try {
                const response = await httpService.get(`panchang/monthly?month=${monthName}&year=${currentYear}&app_language=${app_language}&data_language=${data_language}`);
                setEvents(response.data);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                console.error("Error fetching events:", error.message);
            }
        }
    
        const fetchholidays = async () => {
            setLoading(true);
            try {
                const response = await httpService.get(`holidaylist?country=en.indian&year=${currentYear}`);
                setHolidays(response.data || []);
                setLoading(false);
            } catch (error) {
                setLoading(false);
                console.error("Error fetching holidays:", error.message);
            }
        }
    
        const fetchpanchang = async () => {
            setPanchangLoading(true);
            try {
                const response = await httpService.get(`panchang/daily?date=${curr_date}&app_language=${app_language}&data_language=${data_language}`);
                setpanchangDetails(response.data);
                setPanchangLoading(false);
    
            } catch (error) {
                setPanchangLoading(false);
                console.error("Error fetching panchang:", error.message);
            }
        }

        const next = () => {
                const newMonthStart = monthStart.clone().add(1, 'months').date(1);
                if (newMonthStart.month() === 0) {
                    setCurrentYear(currentYear + 1);
                }
                setMonthStart(newMonthStart);
                const storedDate = localStorage.getItem("CURR_DATE");
                if (storedDate) {
                    let dateFromLocalStorage = moment(storedDate, 'DD/MM/YY');
                    let dateFromRedux = moment(curr_date, 'DD/MM/YY');
                    const currentDay = dateFromLocalStorage.date();
                    let nextMonthDate = dateFromRedux.clone().add(1, 'months');
                    const lastDayNextMonth = nextMonthDate.clone().endOf('month').date();
                    if (currentDay > lastDayNextMonth) {
                        nextMonthDate = nextMonthDate.date(lastDayNextMonth);
                    } else {
                        nextMonthDate = nextMonthDate.date(currentDay);
                    }
                    dispatch(setDate(nextMonthDate.format('DD/MM/YY')));
                }
            };
        
            const previous = () => {
                const newMonthStart = monthStart.clone().subtract(1, 'months').date(1);
                if (newMonthStart.month() === 11) {
                    setCurrentYear(currentYear - 1);
                }
                setMonthStart(newMonthStart);
                const storedDate = localStorage.getItem("CURR_DATE");
                if (storedDate) {
                    let dateFromLocalStorage = moment(storedDate, 'DD/MM/YY');
                    let dateFromRedux = moment(curr_date, 'DD/MM/YY');
                    const currentDay = dateFromLocalStorage.date();
                    let prevMonthDate = dateFromRedux.clone().subtract(1, 'months');
                    const lastDayPrevMonth = prevMonthDate.clone().endOf('month').date();
                    if (currentDay > lastDayPrevMonth) {
                        prevMonthDate = prevMonthDate.date(lastDayPrevMonth);
                    } else {
                        prevMonthDate = prevMonthDate.date(currentDay);
                    }
                    dispatch(setDate(prevMonthDate.format('DD/MM/YY')));
                }
            };


    useEffect(() => {
        fetchMonthlyPanchang();
        fetchholidays();
    }, [app_language, data_language, monthStart, currentYear]);


    useEffect(() => {
        fetchpanchang();
    }, [app_language, data_language, curr_date]);


    const renderDays = () => {
        const days = [];
        for (let i = 0; i < adjustedStartDate; i++) {
            days.push(
                <div
                    key={`empty-${i}`}
                    className="border border-gray-200 rounded-lg"
                    style={{ ...normalDayStyles, height: '120px', width: '50px' }}
                ></div>
            );
        }

        for (let i = 1; i <= monthEnd.date(); i++) {
            const currentDate = monthStart.clone().date(i).format('YYYY-MM-DD');
            let monthNumber = monthStart.month();
            let curr = moment().startOf('year').year(currentYear).month(monthNumber).date(i);
            const today = curr.format("DD MMMM YYYY dddd");
            const isCurrentDate = moment().isSame(currentDate, 'day');  // for Dynamic Day 
            // const isCurrentDate = isSameDay(moment('2024-07-07'), currentDate); // for testing purpose any date
            const isSunday = moment(currentDate).day() === 0;
            const temp = monthStart.clone().date(i).format("YYYY-MM-DD");
            const isHoliday = holidays[monthName] && Array.isArray(holidays[monthName]) ? holidays[monthName].find(h => h.date === temp) : null;
            const todayEvents = events[today];
            const isEkadashi = isTithiPresent(todayEvents, 'ఏకాదశి', ekadashiTranslations);
            const isAmavasya = isTithiPresent(todayEvents, 'అమావాస్య', amavasyaTranslations);
            const isPurnima = isTithiPresent(todayEvents, 'పౌర్ణమి', purnimaTranslations);
            let dayStyles = getDayStyles(isCurrentDate, isEkadashi, isPurnima, isAmavasya, isSunday, isHoliday);
            const dynamicBorder = `1px solid ${dayStyles.customBorderColor}`;
            const tithiLabel = (selectedTranslation.labels.gridTithi);
            const tithiArray = events[today] && events[today][0] && Array.isArray(events[today][0][tithiLabel]) ? events[today][0][tithiLabel] : [];
            const moonsignArray = events[today] && Array.isArray(events[today][0].Moonsign) ? events[today][0].Moonsign : [];
            const nakshatraLabel = (selectedTranslation.labels.gridNakshatra);
            const nakshatraArray = events[today] && events[today][0] && Array.isArray(events[today][0][nakshatraLabel]) ? events[today][0][nakshatraLabel] : [];
            const day = curr.format("DDMMYY");
            days.push(
                <Link to={`/detailedinfo/${day}`} key={i} className="relative" style={dayStyles}>
                    <div className=" p-1 rounded-lg">
                        <h6 className={`absolute left-1 top-6  text-[5px] `} >
                            <span className={`${dayStyles.innernumberColor} ${dayStyles.numberBackground} rounded-md text-[5px]`} style={{ border: dynamicBorder,padding:'2px' }}>
                                {events[today] && events[today][0].local_date.join(',')}
                            </span>
                        </h6>
                        <span className='text-[5px] '>{tithiArray.length > 0 && (
                            <>
                                <div>
                                    {tithiArray[0].split(' ')[0]} {tithiArray[0].split(' ')[2] || ''}
                                </div>
                                {tithiArray.length > 1 && (
                                    <div>
                                        {tithiArray[1].split(' ')[0]}
                                    </div>
                                )}
                            </>
                        )}</span>
                        <div className='absolute flex flex-col top-12'>
                            <div className='flex flex-row'>
                                <PiMoon className='text-[7px] mr-1'/>
                                <h6 className='text-[5px] '>
                                    {moonsignArray.length > 0 && (
                                        <>
                                            <div>
                                                {moonsignArray[0].split(' ')[0]} {moonsignArray[0].includes('upto') ? moonsignArray[0].split('upto ')[1].replace(/(AM|PM|,.*$)/g, '').trim() : ''}
                                            </div>
                                            {moonsignArray.length > 1 && (
                                                <div>
                                                    {moonsignArray[1]}
                                                </div>
                                            )}
                                        </>
                                    )}
                                </h6>
                            </div>
                            <div className='flex flex-row '>
                                <SlStar className='text-[7px]  mr-1'/>
                                <h6 className='text-[5px] '>{nakshatraArray.length > 0 && (
                                    <>
                                        <div>
                                            {nakshatraArray[0].split(' ')[0]} {nakshatraArray[0].includes('upto') ? nakshatraArray[0].split('upto ')[1].replace(/(AM|PM|,.*$)/g, '').trim() : ''}
                                        </div>
                                        {nakshatraArray.length > 1 && (
                                            <div>
                                                {nakshatraArray[1].split(' ')[0]}
                                            </div>
                                        )}
                                    </>
                                )}
                                </h6>
                            </div>
                        </div>
                    </div>
                    <div className={`absolute text-xs  top-6 left-5 ${dayStyles.numberColor}`}>{i}</div>
                    <div className="absolute bottom-0 left-1 ">
                        <div className='flex flex-col'>
                            <div className='flex '>
                                <FiSunrise className='text-[6px] mr-1 mb-2' />
                                <h6 className=' font-normal whitespace-nowrap' style={{ fontSize: "6px" }}>{events[today] ? events[today][0].Sunrise : 'N/A'}</h6>
                            </div>
                            <div className='flex  '>
                                <FiSunset className='text-[6px] mr-1 mb-2' />
                                <h6 className=' font-medium whitespace-nowrap' style={{ fontSize: "6px" }}>{events[today] ? events[today][0].Sunset : 'N/A'}</h6>
                            </div>
                        </div>
                    </div>
                </Link>
            );
        }
        return days;
    };
    return (
        <div className=' flex justify-center items-center '>
            {/* <h1>Mobile Calendar</h1> */}
            <div style={{ maxWidth: "390px" }}>
                <div className='flex items-center justify-between mt-6'>
                    <div className='flex flex-col'>
                        <h6 className='text-lg font-bold'>
                            {t(selectedTranslation.labels.calendar)},<span className='font-normal'>{selectedTranslation.labels[monthName]}, {currentYear}</span>
                        </h6>
                        <div className='flex gap-2'>
                            <img src={Calmoon} alt="calmoon" className="w-14 h-14" />
                            <p>
                                {panchangDetails && panchangDetails['Vikram Samvat'] && (
                                    panchangDetails['Paksha']
                                )}, {t(selectedTranslation.labels.purnima)}<br />
                                {panchangDetails && panchangDetails['Vikram Samvat'] && (
                                    panchangDetails['Vikram Samvat']
                                )}, {t(selectedTranslation.labels.vikram)}
                            </p>
                        </div>
                    </div>
                    <div className='flex flex-col items-end gap-3'>
                        <span className="text-sm font-semibold">
                            {moment(curr_date, "DD/MM/YY").format("DD ")}
                            {t(selectedTranslation.labels[moment(curr_date, "DD/MM/YY").format("MMMM")])},
                            {moment(curr_date, "DD/MM/YY").format("YYYY")}
                            <span>
                                (
                                {storedLanguage === "en"
                                    ? moment(curr_date, "DD/MM/YY").format("dddd")
                                    : t(
                                        selectedTranslation.labels[
                                        moment(curr_date, "DD/MM/YY").format("dddd").toLowerCase()
                                        ]
                                    )}
                                )
                            </span>
                        </span>
                        <div>
                            {panchangDetails && panchangDetails['festivals'] && panchangDetails['festivals'].length > 0 ? (
                                panchangDetails['festivals'].map((festival, index) => (
                                    <span key={index} className='mr-1 text-xs font-medium text-gray-500 underline text'>
                                        {festival},
                                    </span>
                                ))
                            ) : null}

                        </div>
                    </div>
                </div>
                <div className='flex items-center justify-between text-[10px]'>
                    <div>
                        <button
                            className={`p-2 rounded-lg flex items-center justify-center 
                                                        ${panchangloading || (monthStart.month() === 0 && currentYear === 2024)
                                    ? 'bg-[#F6F6F6] cursor-not-allowed'
                                    : 'bg-[#F6F6F6]'}`}
                            onClick={previous}
                            disabled={panchangloading || (monthStart.month() === 0 && currentYear === 2024)}
                        >
                            <FaChevronLeft />
                            <span className='ml-1'>{t(selectedTranslation.labels.prev)}</span>
                        </button>
                    </div>
                    <div className=''>
                        <button
                            className={`p-2 rounded-lg flex items-center justify-center 
                                                    ${panchangloading || (monthStart.month() === 11 && currentYear === 2026)
                                    ? 'bg-[#F6F6F6] cursor-not-allowed'
                                    : 'bg-[#F6F6F6]'}`}
                            onClick={next}
                            disabled={panchangloading || (monthStart.month() === 11 && currentYear === 2026)}
                        >
                            <span className='mr-1'>{t(selectedTranslation.labels.next)}</span>
                            <FaChevronRight />
                        </button>
                    </div>
                </div>
                {loading ? <div> <Loading />  </div> : <Mobileweekdays />}
                <div className="grid grid-cols-7 gap-2">
                    {loading && panchangloading ? <div></div> : renderDays()}
                </div>
                <Notes panchangDetails={panchangDetails} />
                <Festivals />
            </div>
        </div>
    )
}

export default Mobilecalendar;